import React from 'react';
import { connect } from 'react-redux';
import {
  isEqual as isEqualDate,
  getDateRange,
  toFromDate,
  toToDate
} from '~/utils/dateHelpers';
import BoxTimingChart from '~/widgets.new/BoxTimingChart';
import BoxMissPickChart from '~/widgets.new/BoxMissPickChart';
import DatePicker from '~/components/DatePicker';

import style from './widget.scss';

class UserBoxStats extends React.Component {
  constructor(props) {
    super(props);

    const dateRange = getDateRange(
      props.indata.from,
      props.indata.to,
      props.indata.period
    );

    this.state = {
      from: dateRange.from,
      to: dateRange.to,
      previousFrom: dateRange.from,
      previousTo: dateRange.to
    };
  }

  componentWillReceiveProps(nextProps) {
    const dateRange = getDateRange(
      nextProps.indata.from,
      nextProps.indata.to,
      nextProps.indata.period
    );
    if (
      !isEqualDate(toFromDate(this.state.previousFrom), dateRange.from) ||
      !isEqualDate(toToDate(this.state.previousTo), dateRange.to)
    ) {
      this.setState({
        from: dateRange.from,
        to: dateRange.to,
        previousFrom: dateRange.from,
        previousTo: dateRange.to
      });
    }
  }

  render() {
    return (
      <div className={this.props.className}>
        <h5 className={style.title}>{this.props.indata.title}</h5>
        {this.props.indata.showDateFields && (
          <div>
            <div className="pullLeft" style={{ width: '50%' }}>
              <DatePicker
                label="From"
                locale="us"
                sundayFirstDayOfWeek
                onChange={from => {
                  this.setState({ from });
                }}
                value={this.state.from}
              />
            </div>
            <div className="pullRight" style={{ width: '50%' }}>
              <DatePicker
                label="To"
                locale="us"
                sundayFirstDayOfWeek
                onChange={to => {
                  this.setState({ to });
                }}
                value={this.state.to}
              />
            </div>
            <div className="clear" />
          </div>
        )}
        <BoxTimingChart.widget
          indata={{
            ...this.props.indata,
            period: 'fixed_date',
            from: this.state.from,
            to: this.state.to,
            title: null
          }}
        />
        <BoxMissPickChart.widget
          indata={{
            ...this.props.indata,
            period: 'fixed_date',
            from: this.state.from,
            to: this.state.to,
            title: null
          }}
        />
      </div>
    );
  }
}
const mapStateToProps = () => ({});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(
  UserBoxStats
);



// WEBPACK FOOTER //
// ./app/widgets.new/UserBoxStats/widget.js